<template>
  <div class="px-4 py-5 list-item-component">
    <div class="vx-row md:px-4">
      <div class="vx-col w-1/2 items-center">
        <div class="flex items-center mb-1">
          <span class="text-primary mr-2"># {{ data.kategori }}</span>
          <span class="">{{ data.tanggal }}</span>
        </div>
        <div class="flex items-center">
          <h5 class="tranksaksi-title items-center mb-1">
            {{ data.name }}
          </h5>
          <div class="tranksaksi-tags ml-2 mt-1 flex">
            <vs-chip transparent v-for="(tag, index) in data.tags" :key="index" :color="asetLabelColor(tag)">
              {{ asetLabelText(tag) }}
            </vs-chip>
          </div>
        </div>
      </div>

      <div class="vx-col w-1/6 pt-4">
        <div class="vx-row">
          <div class="vx-col w-1/4 flex items-center justify-start">
            <p>Rp.</p>
          </div>
          <div class="vx-col w-3/4 flex items-center justify-end">
            <h5>{{formatTotal(data.task_price)}}</h5>
          </div>
        </div>
      </div>

      <div class="vx-col w-1/6 pt-4 text-center">
        <div class="vx-row">
          <div class="vx-col w-1/2 justify-center">
            <h5>{{formatTotal(data.task_quantity)}}</h5>
          </div>
          <div class="vx-col w-1/2 flex items-center justify-center">
            <p>{{ data.satuan }}</p>
          </div>
        </div>
      </div>

      <div class="vx-col w-1/6 pt-4">
        <div class="vx-row">
          <div class="vx-col w-1/4 flex items-center justify-start">
            <p>Rp.</p>
          </div>
          <div class="vx-col w-3/4 flex items-center justify-end">
            <h5>{{formatTotal(data.task_total)}}</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default{
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      //data: this.$store.getters['aset/getTask'](this.asetId)
    }
  },
  computed: {
    asetLabelText () {
      return (text) => {
        const tags = this.$store.state.aset.asetTags
        return tags.find((tag) => {
          return tag.slug === text
        }).name
      }
    },
    asetLabelColor () {
      return (label) => {
        const tags = this.$store.state.aset.asetTags
        return tags.find((tag) => {
          return tag.slug === label
        }).color
      }
    }
  },
  methods: {
    persen(val) {
      return parseInt(val)
    },
    formatTotal(value) {
      let val = (value/1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  }
}
</script>
